module.exports = __webpack_public_path__ + "newsIco.webp?a15f7678ef396a12e636d141381d08ce";